<template>
  <div>
    <VueSlickCarousel :arrows="true" :dots="false">
      <div class="sample-image-gallery"  v-for="(img, i) in  sampleImages" :key="i">
        <img   :src="img.path" alt=""/>
      </div>
    </VueSlickCarousel>
  </div>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  props:{
    sampleImages: Object
  },
  name: "Slider",
  components: { VueSlickCarousel },
};
</script>

<style lang="scss">
button.slick-arrow.slick-prev , button.slick-arrow.slick-next{
  background: blue;
  height: 30px;
  width: 30px;
  z-index: 9999;
}
button.slick-arrow.slick-prev {
  left:-18px
}
 button.slick-arrow.slick-next{
 right:-18px
}
.sample-image-gallery{

}
</style>